import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { requirementService } from '../../services/requirementService';
import RequirementPrintDocument from '../../components/Requirements/RequirementPrintDocument';
import {
  REQUIREMENT_PRINT_PAGE_STYLES,
  REQUIREMENT_PRINT_STYLES,
} from '../../components/Requirements/requirementPrintStyles';
import { downloadRequirementPdf } from '../../utils/generateRequirementPdf';

const PrintRequirement = () => {
  const { id } = useParams();
  const [requirement, setRequirement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await requirementService.getRequirement(id);
        if (response.success) setRequirement(response.data);
      } catch (error) {
        console.error('Error al cargar requerimiento:', error);
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  const handleDownloadPdf = async () => {
    if (!requirement || pdfLoading) return;
    setPdfLoading(true);
    try {
      await downloadRequirementPdf(requirement);
    } catch (error) {
      console.error('Error al generar PDF:', error);
      alert(error?.message || 'No se pudo generar el PDF');
    } finally {
      setPdfLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4" />
          <p className="text-gray-600">Cargando requerimiento...</p>
        </div>
      </div>
    );
  }

  if (!requirement) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-red-600 text-lg">Requerimiento no encontrado</p>
      </div>
    );
  }

  return (
    <div className="req-print-root">
      <style>{`${REQUIREMENT_PRINT_PAGE_STYLES}${REQUIREMENT_PRINT_STYLES}`}</style>

      <div className="print-actions no-print">
        <button
          type="button"
          onClick={handleDownloadPdf}
          disabled={pdfLoading}
          className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium shadow-md transition-colors disabled:opacity-60"
        >
          {pdfLoading ? 'Generando PDF…' : 'PDF'}
        </button>
        <button
          type="button"
          onClick={() => window.close()}
          className="px-5 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 font-medium shadow-md transition-colors"
        >
          Cerrar
        </button>
      </div>

      <RequirementPrintDocument requirement={requirement} />
    </div>
  );
};

export default PrintRequirement;
